import Mutations from './mutations'
import Actions from './actions'
import Getters from './getters'
import State from './state'
import RootGetters from '../root/getters'

export default {
  namespaced: true,
  state: State,
  mutations: Mutations,
  actions: Actions,
  getters: Getters,
  rootGetters: RootGetters
}
